import React from 'react';

import Seo from '../ui/Seo';
import PageHero from '../sections/PageHero';
import TradeTicker from '../sections/TradeTicker';
import Pledge from '../sections/Pledge';
import StoryDeck from '../sections/StoryDeck';
import SectionHead from '../sections/SectionHead';
import Faqs from '../sections/Faqs';
import Cta from '../sections/Cta';

import CodeCompliance from "../media/images/safety-standards/code-compliance.jpg";
import SurgeProtection from "../media/images/safety-standards/surge-protection.jpg";
import FireSafety from "../media/images/safety-standards/fire-safety.jpg";
import GroundingBonding from "../media/images/safety-standards/grounding-bonding.jpg";
import SafetyInspections from "../media/images/safety-standards/safety-inspections.jpg";
import EmergencyLighting from "../media/images/safety-standards/emergency-lighting.jpg";

const content =
[
    {
        title: "Electrical Code Compliance",
        text: "At Smart Electric Solutions, we ensure that all electrical installations meet the latest local, state, and national electrical codes. Our commitment to compliance guarantees a safe and legally sound environment for your home or business.",
        imgSrc: CodeCompliance,
        alt: "Electrical Code Compliance - Smart Electric Solutions",
        focus: "50%",
    },
    {
        title: "Fire Safety Systems",
        text: "Electrical fires are a serious risk. Our expert electricians install and maintain fire safety systems, including smoke detectors, heat sensors, and circuit breakers, to safeguard your property and occupants.",
        imgSrc: FireSafety,
        alt: "Fire Safety Systems - Smart Electric Solutions",
        focus: "60%",
    },
    {
        title: "Surge Protection Systems",
        text: "Protect your property and devices from power surges with our advanced surge protection solutions. From whole-home systems to targeted surge protectors, we ensure safety and longevity for your electronics.",
        imgSrc: SurgeProtection,
        alt: "Surge Protection Systems - Safety and Reliability",
        focus: "50%",
    },
    {
        title: "Grounding and Bonding",
        text: "Proper grounding and bonding are essential to prevent electrical shocks and fires. We provide thorough inspections and upgrades to ensure your system is safe and meets current safety standards.",
        imgSrc: GroundingBonding,
        alt: "Grounding and Bonding - Electrical Safety",
        focus: "50%",
    },
    {
        title: "Safety Inspections",
        text: "Our comprehensive safety inspections identify potential hazards, ensuring peace of mind for your family or employees. We provide detailed reports and recommendations to address any issues found.",
        imgSrc: SafetyInspections,
        alt: "Safety Inspections - Electrical Safety Assurance",
        focus: "50%",
    },
    {
        title: "Emergency Lighting and Exit Systems",
        text: "Ensure compliance with safety regulations and protect building occupants with reliable emergency lighting and exit systems. Our team installs and maintains systems that function perfectly when you need them most.",
        imgSrc: EmergencyLighting,
        alt: "Emergency Lighting and Exit Systems - Building Safety",
        focus: "50%",
    }
];

export default function SafetyStandards() {
    return (
        <>
            <Seo
                title="Safety Standards"
                description="Code compliance, safety inspections, grounding and bonding, surge protection, fire safety and emergency lighting, held to South Florida standards."
                keywords="electrical safety, code compliance, safety inspections, grounding and bonding, surge protection, fire safety, emergency lighting"
                path="/safety-standards"
                schema={{
                    '@type': 'WebPage',
                    name: 'Safety Standards',
                    description: 'Code compliance, safety inspections, grounding and bonding, surge protection, fire safety and emergency lighting, held to South Florida standards.',
                    url: 'https://smartelectric.solutions/safety-standards'
                }}
            />

            <PageHero
                eyebrow="Systems"
                title="The part of the job nobody sees."
                lead="Grounding, bonding, protection and life safety are what separate an installation that passes from one that lasts. We do not treat them as optional line items."
                backdrop={content[0].imgSrc}
                focus={`${content[0].focus} center`}
                crumbs={[{ label: 'Systems' }, { label: 'Safety Standards' }]}
            />

            <TradeTicker />

            <section className="section section--tight">
                <div className="shell">
                    <Pledge />
                </div>
            </section>

            <section className="section section--ruled">
                <div className="shell">
                    <SectionHead
                        eyebrow="How we work"
                        title="Safety, in practice."
                        lead="What we inspect, what we document, and what we will not sign off on."
                    />
                </div>

                <div style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    <StoryDeck items={content} />
                </div>
            </section>

            <Faqs />
            <Cta />
        </>
    );
}
